// import {Facebook, Linkedin, Youtube, Instagram } from "lucide-react";

export default function Footer() {
    return (
        <footer>
            <div className="mt-8 bg-white p-4 shadow-md rounded-lg">
                <p className="text-center">&copy; 2025 Admin. All rights reserved.</p>
            </div>
            
        </footer>
    );
}